<template>
	<v-header title="体检套餐" headerLeftStatus="true" />
	<div class="sysMain">
		<div style=" padding: 0px 10px 0px 10px; ">
			<Tabs value="tab2" v-if="suiteList.length>0">
				<TabPane label="套餐列表" name="tab1">
					<p v-html="view.activity"></p>
					<!-- <div style=" text-align: center;background-color: #A63E5F;">
						<label style="font-size: 20px;color:white;">芳&nbsp;华&nbsp;春&nbsp;三&nbsp;月&nbsp; &nbsp; &nbsp; &nbsp;健&nbsp;康&nbsp;女&nbsp;人&nbsp;季</label><br />
						<label style="font-size: 15px;color:white;">&nbsp; &nbsp;——省妇幼女性特色体检优惠活动&nbsp; &nbsp;</label><label style="font-size: 12px;color:white;">3.1-4.30</label>
					</div>
					 -->
					<Layout @click="detail(item)" v-for=" item in suiteList"
						style="margin-bottom: 10px; background-color: white; border-style: solid; border-width:1px; border-color:#EBEBEB; border-radius: 5px 5px 5px 5px;">
						<Header
							style="padding-left: 10px;padding-right: 0px;height: 40px;line-height: 40px;background-color: white; ">
							<h2>
								<span v-show="!this.isNullOrEmptyEx(item.category)"
									style="color: #3C9DFF; background: #E7F4FF;padding: 0 0.07rem;vertical-align: 1px;">{{item.category}}</span>
								<b style="padding-left: 5px;">{{item.suiteName}}</b>
							</h2>
						</Header>
						<Layout>
							<Content style=" background-color: white;">
								<div v-show="view.activity!==''">
									<Row>
										<Col>
										<div class="container"
											:style="'width: 100px;height:75px;background-image:url('+require('../../static/wwwroot/suite/'+item.imgUrl)+')' ">
											<img :src="require('../../static/img/th.png')"
												style="width: 50px;height: 18px;" />
										</div>
										</Col>
										<Col flex="auto" style=" max-width: calc(100% - 105px);padding-left: 5px;">
										<Row>
											<Col>
											<div v-line-clamp="2" style="font-size:0.25rem;">
												{{item.synopsis}}
											</div>
											<div v-show="item.tag=='热销'" style="text-align: right;">
												<img  :src="require('../../static/img/hot.png')"
													style="width: 20px;height: 16px;" />
											</div>
											</Col>
										</Row>
										<Row>
											<Col>
											<div v-line-clamp="2" style="font-size:0.2rem;color: #999999;">
												{{item.characteristic}}
											</div>
											</Col>
										</Row>
										</Col>
									</Row>
								</div>
								<div v-show="view.activity==''">
									<Row>
										<Col>
										<img :src="require('../../static/wwwroot/suite/'+item.imgUrl)"
											style="width: 100px;height:75px;" />
										</Col>
										<Col flex="auto" style=" max-width: calc(100% - 105px);padding-left: 5px;">
										<Row>
											<Col>
											<div v-line-clamp="2" style="font-size:0.25rem;">
												{{item.synopsis}}
											</div>
											</Col>
										</Row>
										<Row>
											<Col>
											<div v-line-clamp="2" style="font-size:0.2rem;color: #999999;">
												{{item.characteristic}}
											</div>
											</Col>
										</Row>
										</Col>
									</Row>




								</div>

								<Divider size="small" style="margin-top: 8px; margin-bottom: 0px; " />
							</Content>
						</Layout>
						<Footer style="padding: 10px;background-color: white;">
							<Row>
								<Col span="12">
								<label v-show="!this.isNullOrEmptyEx(item.tag)"
									style="border: 1px solid rgba(255, 67, 65, 0.2);color: #FF4341;">{{item.tag}}</label>
								</Col>
								<Col span="12" style="text-align: right;">
								<Text type="danger">
									<Numeral :value="item.amount" format="0,0.00">
										<template #prefix>
											<strong>¥ </strong>
										</template>
									</Numeral>
								</Text>
								<label v-show="item.orgAmount != item.amount"
									style="text-decoration: line-through;padding-left:10px;">{{item.orgAmount }}</label>
								</Col>
							</Row>
						</Footer>
					</Layout>
				</TabPane>
				<TabPane label="预约流程" name="tab2" style="line-height: 25px; font-size: 13px;">
					<img :src="require('../../static/wwwroot/Images/lct.png')"
						style="width: 100%; padding-bottom: 10px;" />
					<div v-show="view.reservation==''">
						<ROW>
					1.选择需要的体检套餐，完成下单<br />
					2.可在付款完成后，到首页“我的预约”中预约体检。<br />
					3.体检当日现场出示身份证即可体检， 注 : 到医院无需另行支付其他费用(现场加项、申请快递报告除外)<br />
					4.体检报告一般在3-15个工作日出结果，支持在线查询报告、报告邮寄，具体的报告领取方式和时间可现场咨询医院工作人员。
					</ROW>
					</div>
					<div v-show="view.reservation!==''">
						<p v-html="view.reservation" style="font-size:large;padding: 10px 5px;"></p> 
										
					</div>
				</TabPane>
				<TabPane label="体检须知" name="tab3">
					<Timeline>
						<TimelineItem color="blue">
							<label style="color:#1890ff ; font-size: 15px; ">检查前</label>
							<Row>
								<Col>
								1.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								体检前一天请您清淡饮食,勿饮酒、勿劳累。体检当天请空腹禁食。
								</Col>
							</Row>
							<Row>
								<Col>
								2.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px; ">
								体检前一天要注意休息，晚上8点后不再进食。避免剧烈运动和情绪激动，保证充足睡眠，以免影响检查结果。
								</Col>
							</Row>
							<Row>
								<Col>
								3.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								例假期间不宜做妇科、尿液体检。
								</Col>
							</Row>
						</TimelineItem>
						<TimelineItem color="blue">
							<label style="color:#1890ff ; font-size: 15px; ">体检中</label>
							<Row>
								<Col>
								1.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								需空腹检查的项目为抽血、腹部B超、数字胃肠，胃镜及其它标注的检查项目。
								</Col>
							</Row>
							<Row>
								<Col>
								2.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								做膀胱、子宫、附件B超时请勿排尿，如无尿需饮水至膀胱充盈。做妇科检查前应排空尿。
								</Col>
							</Row>
							<Row>
								<Col>
								3.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								未婚女性不做妇科检查；怀孕的女性请预先告知医护人员,不安排做放射及其他有影响的检查。
								</Col>
							</Row>
							<Row>
								<Col>
								4.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								做放射线检查前,请您除去身上佩戴的金银、玉器等饰物。
								</Col>
							</Row>
							<Row>
								<Col>
								5.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								核磁共振检查，应禁止佩带首饰、手表、传呼、手机等金属物品，磁卡也不应带入检查室，以防消磁。
								</Col>
							</Row>
						</TimelineItem>
						<TimelineItem color="blue">
							<label style="color:#1890ff ; font-size: 15px; ">体检后</label>
							<Row>
								<Col>
								1.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								全部项目完毕后请您务必将体检单交到前台。
								</Col>
							</Row>
							<Row>
								<Col>
								2.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								请您认真听取医生的建议,及时复查、随诊或进一步体检治疗。
								</Col>
							</Row>
							<Row>
								<Col>
								3.
								</Col>
								<Col flex="auto" style=" max-width: calc(100% - 15px);padding-left: 5px;">
								请您保存好体检结果，以便和下次体检结果作对照也可作为您就医时的资料。
								</Col>
							</Row>
						</TimelineItem>
						<TimelineItem color="white">
						</TimelineItem>
					</Timeline>
				</TabPane>
			</Tabs>
		</div>
		<div style="text-align:center" v-show="view.initComplete===true&&suiteList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import footer from "@/components/footer/index";
	import {
		sysPost
	} from '@/utils/api'
	import {
		getToken,
		getExclusiveId
	} from '@/utils/auth'



	export default {
		name: 'contactus',
		data() {
			return {
				view: {
					initComplete: false,
					exclusiveId: '',
					activity: '',
					reservation:'',
				},
				suiteList: [],
				suite: {}
			};
		},
		created() {
			var token = getToken();
			if (token) this.view.activity = token.viewActivity;
			if (token) this.view.reservation = token.reservation;
			var exclusiveid = getExclusiveId();
			if (!this.isNullOrEmptyEx(exclusiveid)) this.view.exclusiveId = exclusiveid;
			this.init();
		},
		methods: {
			init() {
				var that = this;
				sysPost(that, {
					"url": 'Suite/List',
					"data": {
						ExclusiveId: this.view.exclusiveId
					}
				}, function(result) {
					that.view.initComplete = true;
					that.suiteList = result;
				})
			},
			detail(item) {
				this.$router.push({
					path: '/suiteDetail',
					query: {
						id: item.id,
					}
				})
			},
		},
		components: {
			"v-header": header,
			"v-footer": footer
		}
	}
</script>


<style>
	.container {
		position: relative;
		/* 相对定位 */

		/* background-image: url('/src/static/img/suite_female.png'); 第一张图片路径 */
		background-size: cover;
		/* 自适应尺寸 */
	}

	.overlay {
		position: absolute;
		/* 绝对定位 */
		top: 0;
		/* 水平居中 */
		left: 0;
		/* 垂直居中 */
		transform: translate(0, 0);
		/* 移动到正确位置 */
		z-index: 1;
		/* 放置于前景 */
		width: 10px;
		/* 第二张图片宽度 */
		height: 10px;
		/* 第二张图片高度 */
		background-image: url('/src/static/img/th.png');
		/* 第二张图片路径 */
		background-repeat: no-repeat;
		/* 不重复显示 */
		background-position: center;
		/* 居中显示 */
		opacity: 0.7;
		/* 透明度 */
	}
</style>